var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var modal = require('../layout/components/modal');
var modalForm = require('../layout/components/modalForm');
var header = require('../layout/components/header');
var buttonElement = require('../components/button');
var permissionModal = modalForm(require('./models/permission'));
var rowActionDropdown = require('../components/rowActionDropdown');
var permissionGroupFilter = require('../libs/permissionGroupFilter');
var requestStatusHandler = require('../layout/components/requestStatusHandler');
var RequestStatus = require('../layout/enums/RequestStatus');

var page = {};

function ridRoutePart(record) {
  if (!record || !record['@rid']) return null;
  var rid = record['@rid'].toString();
  return rid.charAt(0) === '#' ? rid.slice(1) : rid;
}

function ancestorHref(ancestor) {
  var rid = ridRoutePart(ancestor);
  if (!rid) return '/';
  return ancestor['@class'] === 'Dashboard'
    ? '/dashboard/' + rid
    : '/location/' + rid;
}

page.oninit = function () {
  var ctrl = this;
  header.vm.activeTab('Dashboards');

  ctrl.dashboard = prop({});
  ctrl.permissions = prop([]);
  ctrl.groups = prop([]);
  ctrl.routeId = m.route.param('id');
  ctrl.requestStatus = prop(RequestStatus.PENDING);
  ctrl.requestStatusCode = prop();

  ctrl.isCurrentRoute = function (routeId) {
    return ctrl.routeId === routeId;
  };

  ctrl.reset = function () {
    ctrl.dashboard({});
    ctrl.permissions([]);
  };

  ctrl.init = function () {
    var routeId = ctrl.routeId;
    ctrl.requestStatus(RequestStatus.PENDING);
    ctrl.requestStatusCode();

    return Promise.all([
      loaders.requestWithLoader({
        url: '/api/v1/dashboard/' + routeId,
        method: 'GET',
        background: true
      }),
      loaders.requestWithLoader({
        url: '/api/v1/dashboard/' + routeId + '/permissions',
        method: 'GET',
        background: true,
      }),
      loaders.requestWithLoader({
        url: '/api/v1/group/',
        method: 'GET',
        background: true
      })
    ])
    .then(function (results) {
      if (ctrl.isCurrentRoute(routeId)) {
        var dashboard = results[0] || {};
        var permissions = Array.isArray(results[1]) ? results[1] : [];
        var groups = Array.isArray(results[2]) ? results[2] : [];
        ctrl.dashboard(dashboard);
        ctrl.permissions(permissions.map(function (record) {
          return Object.assign({}, record, {
            dashboard: '#' + routeId,
            group: record.in
          });
        }));
        ctrl.groups(groups);
        ctrl.requestStatus(RequestStatus.SUCCESS);
        m.redraw();
      }
      return results;
    })
    .catch(function (error) {
      console.error('Unable to load dashboard permissions:', error);
      if (ctrl.isCurrentRoute(routeId)) {
        ctrl.requestStatusCode(error && (error.status || error.code || (error.response && error.response.status)));
        ctrl.requestStatus(RequestStatus.ERROR);
        m.redraw();
      }
      return null;
    });
  };

  modal.on('closed', ctrl.init);
  
  return ctrl.init();
};

page.onbeforeupdate = function () {
  var ctrl = this;
  var nextRouteId = m.route.param('id');

  if (!nextRouteId || ctrl.routeId === nextRouteId) {
    return true;
  }

  ctrl.routeId = nextRouteId;
  ctrl.reset();
  ctrl.init();
  return true;
};

page.onremove = function () {
  modal.off('closed', this.init);
};

page.view = function (vnode) {
  var ctrl = this;
  if (ctrl.requestStatus() !== RequestStatus.SUCCESS) {
    return m(requestStatusHandler, {
      requestStatus: ctrl.requestStatus,
      requestStatusCode: ctrl.requestStatusCode,
      onRetry: ctrl.init
    });
  }

  function heading () {
    if (ctrl.dashboard().ancestors) {
      return m('div.mb3.bb.bw1.b--mid-gray.near-white.f-subheadline.pb2.flex.flex-wrap', [
        ctrl.dashboard().ancestors.map(function (ancestor, idx) {
          if (ancestor.name === 'root') {
            return m('div.mr2.dib-ns.nowrap', [
              m(m.route.Link, {href:'/'}, 'Home'),
              ' / '
            ]);
          } else if (ancestor.name === ctrl.dashboard().name) {
            return m('div.mr2.dib-ns.nowrap', [
              ctrl.dashboard().name,
              ' - ',
              ' Permissions '
            ])
          } else {
            return m('div.mr2.dib-ns.nowrap', [
              m(m.route.Link, {href: ancestorHref(ancestor)}, ancestor.name),
              ' / '
            ]);
          }
        }),
      ])
    } else {
      return m('div.mb3.bb.bw1.b--mid-gray.near-white.f-subheadline.pb2', [
        m('div.mr2.dib-ns.nowrap', [
          m(m.route.Link, {href:'/'}, 'Home'),
          ' - ',
          ' Permissions '
        ])
      ])
    }
  }

  return m('div', {class:'container'}, [
    heading(),
    m('table.w-100', [
      m('thead.f3', [
        m('tr', [ 
          m('th', ''),
          m('th', 'Group Name'),
          m('th', 'Read Permission'),
          m('th', 'Write Permission'),
          m('th', 'Actions')
        ])
      ]),
      m('tbody', [
        ctrl.permissions().map(function (permission) {
          permission.name = `${(permission.group && permission.group.name) || 'Unknown group'} permission`;
          var permissionGroupRid = permission.in && permission.in['@rid'];
          var group = ctrl.groups().find(function (groupRecord) {
            return groupRecord['@rid'] === permissionGroupRid;
          });
          return m('tr.tc', [
            m('td'),
            m('td', (group && group.name) || (permission.group && permission.group.name) || 'Unknown group'),
            m('td', (permission.read == 1 || permission.write == 1 ? 'Yes' : 'No')),
            m('td', (permission.write  == 1 ? 'Yes' : 'No')),
            m('td.nowrap', [
              m(rowActionDropdown, {
                items: [
                  {
                    label: 'Edit Permission',
                    icon: 'ion-ios-compose',
                    onclick: permissionModal.editDialogue.bind(permissionModal, permission)
                  },
                  {
                    label: 'Delete Permission',
                    icon: 'ion-ios-trash',
                    class: 'red',
                    onclick: permissionModal.deleteDialogue.bind(permissionModal, permission)
                  }
                ]
              })
            ])
          ])
        })
      ])
    ]),
    m(buttonElement, {
      label: 'Add Group',
      func: permissionModal.editDialogue.bind(permissionModal, {
        dashboard: ctrl.dashboard()['@rid'],
        read: 0,
        write: 0,
        existingGroupRids: permissionGroupFilter.existingGroupRidsFromPermissions(ctrl.permissions())
      }),
      class: 'btn-default icon-right mt3'
    }),
  ])
}

page.__testables = {
  ancestorHref: ancestorHref
};

module.exports = page;
